import { PRODUCTS_SERVICE } from "@/services/products.service.js";

const state = {postProductOutput: false, getProductsOutput: {}, putProductOutput: false, getProductDetailsOutput: {}, deleteProductByIdOutput: false, getProductBySlugOutput: {}};

const actions = {
    //Service to create products
    postProduct({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postProductRequest');
        
        PRODUCTS_SERVICE.postProduct(input)
            .then(
                output => {
                    commit('postProductSuccess', output);
                },
                error => {
                    commit('postProductFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated products
    getProducts({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getProductsRequest');

        PRODUCTS_SERVICE.getProducts(queryParams)
            .then(
                output => {
                    commit('getProductsSuccess', output);
                },
                error => {
                    commit('getProductsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update products
    putProduct({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putProductRequest');

        PRODUCTS_SERVICE.putProduct(input)
            .then(
                output => {
                    commit('putProductSuccess', output);
                },
                error => {
                    commit('putProductFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get products details
    getProductDetails({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getProductDetailsRequest');

        PRODUCTS_SERVICE.getProductDetails(queryParams)
            .then(
                output => {
                    commit('getProductDetailsSuccess', output);
                },
                error => {
                    commit('getProductDetailsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete products
    deleteProductById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteProductByIdRequest');

        PRODUCTS_SERVICE.deleteProductById(id)
            .then(
                output => {
                    commit('deleteProductByIdSuccess', output);
                },
                error => {
                    commit('deleteProductByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postProduct
    postProductRequest(state) {
        state.postProductOutput = null;
    },
    postProductSuccess(state, output) {
        state.postProductOutput = true;
    },
    postProductFailure(state) {
        state.postProductOutput = false;
    },

    //getProducts
    getProductsRequest(state) {
    },
    getProductsSuccess(state, output) {
        state.getProductsOutput = output;
    },
    getProductsFailure(state) {
        state.getProductsOutput = false;
    },

    //putProduct
    putProductRequest(state) {
        state.putProductOutput = null;
    },
    putProductSuccess(state, output) {
        state.putProductOutput = true;
    },
    putProductFailure(state) {
        state.putProductOutput = false;
    },

    //getProductDetails
    getProductDetailsRequest(state) {
    },
    getProductDetailsSuccess(state, output) {
        state.getProductDetailsOutput = output;
    },
    getProductDetailsFailure(state) {
        state.getProductDetailsOutput = false;
    },

    //deleteProductById
    deleteProductByIdRequest(state) {
        state.deleteProductByIdOutput = null;
    },
    deleteProductByIdSuccess(state, output) {
        state.deleteProductByIdOutput = true;
    },
    deleteProductByIdFailure(state) {
        state.deleteProductByIdOutput = false;
    },
};

export const products = {
    namespaced: true,
    state,
    actions,
    mutations
};